export default "__VITE_ASSET__esHnijVF__"